import { ApolloClient, NormalizedCacheObject } from '@apollo/client/core'
import { defineStore } from 'pinia'

import { Club } from '__generated__/Club'
import { listClubs } from '__generated__/listClubs'
import { LIST_CLUBS_QUERY } from '@base/api/queries/listClubs'
import { ListClubsFilter, ListClubsSort, ClubSortField, SortOrder } from '__generated__/globalTypes'

export const useClubsStore = defineStore({
  id: 'clubs',
  state: () => ({
    clubs: [] as Club[],
    count: 0,
    serverError: false,
    loading: false
  }),
  getters: {},
  actions: {
    async listClubs(
      client: ApolloClient<NormalizedCacheObject>,
      filter: ListClubsFilter,
      sortField: ClubSortField,
      sortOrder: SortOrder,
      offset: number,
      limit: number
    ) {
      try {

        const { data } = await client.query<listClubs>({
          query: LIST_CLUBS_QUERY,
          variables: {
            filter,
            sortField,
            sortOrder,
            offset,
            limit
          },
          fetchPolicy: 'no-cache'
        })
        const { listClubs } = data

        // Include unauthenticated list courses error
        if (
          listClubs.__typename === 'ServerError' ||
          listClubs.__typename === 'UnauthorizedError' ||
          listClubs.__typename === 'UnauthenticatedError' ||
          listClubs.__typename === 'ListClubsErrorOutput'
        ) {
          this.serverError = true
          return
        }
        const { clubs, count } = listClubs
        this.clubs = clubs
        this.count = count
      } catch (e) {
        this.serverError = true
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
})
